const accessToken = process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN;

const environment = process.env.VERCEL_ENV;
const isProduction = environment === "production";
const isPreview = environment === "preview";
const isDevelopment = process.env.NODE_ENV === "development";

export { accessToken, isProduction, environment, isPreview, isDevelopment };
